import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { useMemo } from "react";

export function useRequirementHistoryResources(
  requirement: IRequirementResponse
) {
  return useMemo(
    () => [
      {
        resourceType: "Requirement",
        resourceId: requirement.requirementId
      },
      {
        resourceType: requirement.dataSourceType,
        resourceId: requirement.dataSourceId
      },
      ...(requirement.dataSourceHistory?.map(history => ({
        resourceId: history.dataSourceId,
        resourceType: requirement.dataSourceType
      })) || [])
    ],
    [requirement]
  );
}
